import { render, staticRenderFns } from "./BusinessClientEdit.vue?vue&type=template&id=04972a90&"
import script from "./BusinessClientEdit.vue?vue&type=script&lang=ts&"
export * from "./BusinessClientEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports